export default __webpack_public_path__ + "static/1-d9ac7a990d0c88b55a64a4c342d7d67f.png";